<template>
    <div>
        <p class="stack-m">Schedule invoice retries using the following schedule:</p>
        <table class="table table-definition stack-m">
            <colgroup>
                <col style="width:100px;">
                <col>
            </colgroup>
            <tbody>
            <tr v-for="(attempt, index) in action.attempts">
                <td>Attempt #{{index+1}}</td>
                <td>
                    {{attempt.summary}}
                </td>
            </tr>
            </tbody>
        </table>
        <p>
            <span v-if="hasPushForward">After each attempt push the renewal time forward. </span>
            <span v-if="hasLastAttempt">If the last attempt fails {{lastAttemptSummary}}. </span>
            <span v-if="action.overrideRetryInstruction">Override the previous schedule.</span>
        </p>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'schedule-invoice-retry-summary',
        extends: BaseActionSummary,
        computed: {
            hasPushForward() {
                return this.action.afterAttemptPolicies.length > 0;
            },
            hasLastAttempt() {
                return this.action.afterRetryEndPolicies.length > 0;
            },
            lastAttemptSummary() {
                return this.action.afterRetryEndPoliciesSummary();
            },
        },
    };
</script>

<style scoped>

</style>
